module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "Page_0"
    }
  }), _vm._v(" "), _c('figure', {
    staticClass: "figcenter illowe28_125",
    attrs: {
      "id": "i_frontispiece"
    }
  }, [_c('img', {
    staticClass: "w100",
    attrs: {
      "alt": "Object—matrimony",
      "id": "img_images_i_frontispiece.jpg",
      "src": "3624747857925452935_i_frontispiece.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("“Object—matrimony,” he retorted.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("["), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Page "), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h15.htm#Page_168"
    }
  }, [_vm._v("168")])]), _vm._v("]")])])])]), _vm._v(" "), _c('div', {
    staticClass: "titlepage"
  }, [_c('p', [_c('span', {
    staticClass: "xxlarge"
  }, [_c('i', [_vm._v("The")]), _c('br'), _vm._v("\nMOVING FINGER")])]), _vm._v(" "), _c('p', [_vm._v("BY"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "xlarge"
  }, [_vm._v("NATALIE SUMNER LINCOLN")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUTHOR OF “THE NAMELESS MAN,” “I SPY,” “C. O. D.,”"), _c('br'), _vm._v("\n“THE LOST DESPATCH,” “THE TREVOR CASE,” ETC.")])]), _vm._v(" "), _c('div', {
    staticClass: "figcenter"
  }, [_c('img', {
    attrs: {
      "alt": "publisher's logo",
      "id": "img_images_i_logo.jpg",
      "src": "3624747857925452935_i_logo.jpg"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ILLUSTRATED BY")]), _c('br'), _vm._v("\nCHARLES L. WRENN")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "large"
  }, [_vm._v("D. APPLETON AND COMPANY")]), _c('br'), _vm._v("\nNEW YORK  "), _c('span', {
    staticClass: "gap"
  }, [_vm._v("    LONDON")]), _c('br'), _vm._v("\n1918")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3acf7fcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3186253215635795556_74210-h-2.htm.vue
// module id = 63
// module chunks = 0